import { InfoWindowF, MarkerF } from '@react-google-maps/api'
import { generatePath, useNavigate } from 'react-router-dom'
import { useMemo, useState } from 'react'

import { APP_PATHS } from '__constants__/paths'
import MapProductView from './MapProductView'
import PropTypes from 'prop-types'
import { getIcon } from './helpers'

const MarkerView = (props) => {
  const {
    address,
    _id,
    name,
    pricePerDayWithFees,
    currency,
    topCategory,
    previewImgUrl
  } = props
  const [detailsVisible, setDetailsVisible] = useState(false)

  const navigate = useNavigate()

  const viewDetails = () => {
    navigate(generatePath(APP_PATHS.PRODUCT_SHOW, { productId: _id }))
  }

  const icon = useMemo(() => getIcon(topCategory?.icon), [topCategory?.icon])

  const options = { closeBoxURL: '', enableEventPropagation: true }

  if (!address) return null

  const latitude = address?.location?.[0]
  const longitude = address?.location?.[1]

  return (
    <>
      {detailsVisible && (
        <InfoWindowF
          position={{ lat: latitude, lng: longitude }}
          options={options}>
          <MapProductView
            previewImgUrl={previewImgUrl}
            pricePerDay={pricePerDayWithFees}
            onView={viewDetails}
            currency={currency}
            name={name}
          />
        </InfoWindowF>
      )}
      <MarkerF
        key={_id}
        onClick={() => setDetailsVisible((prev) => !prev)}
        icon={{
          url: icon,
          scaledSize: new window.google.maps.Size(32, 32),
          origin: new window.google.maps.Point(0, 0),
          anchor: new window.google.maps.Point(15, 15)
        }}
        position={{
          lat: latitude,
          lng: longitude
        }}
      />
    </>
  )
}

MarkerView.propTypes = {
  address: PropTypes.object,
  _id: PropTypes.string,
  categoryId: PropTypes.string,
  name: PropTypes.string,
  pricePerDayWithFees: PropTypes.number,
  currency: PropTypes.string,
  topCategory: PropTypes.object,
  previewImgUrl: PropTypes.string
}

export default MarkerView
